<template>
	<div class="popup-container" v-bind:style="style">
		<div class="close-button" v-on:click="closePopup">
			<span>x</span>
		</div>
		<div class="maid-profile">
			<img class="maid-image" src="http://placecage.com/gif/25/25" alt="Maria Chiappe" width="24" height="24" />
			<span class="maid-name">{{name}}</span>
		</div>
		<div class="maid-clean">
			<span class="description-text">Tipo de Limpieza:</span>
			<span class="value-text">{{typeCleaning}}</span>
		</div>
		<div class="maid-actions">
			<span class="description-text">Hora: </span>
			<span class="value-text">{{time}}</span>
			<button type="button" class="btn-maid" v-on:click="actionButton">Editar</button>
		</div>
	</div>
</template>

<script>

	function actionButton() {
		this.$emit('action-popup');
	}

	function closePopup() {
		this.$emit('close-popup');
	}

	function style() {
		const opacityValue = this.visible ? 1 : 0;
		const translate = this.visible ? -20 : 0;
		const zIndexValue = this.visible ? 1 : -1;
		return `opacity:${opacityValue};transform:translateY(${translate}px);z-index:${zIndexValue}`;
	}

	export default {
		name: 'popup-maid',
		computed: {
			style,
		},
		props: {
			name: {
				type: String,
				default: 'Maria Chiappe',
			},
			time: {
				type: String,
				default: '9:30 a.m.',
			},
			typeCleaning: {
				type: String,
				default: 'Profunda',
			},
			visible: {
				type: Boolean,
				default: true,
			},
		},
		methods: {
			actionButton,
			closePopup,
		},
	};
</script>

<style lang="scss" scoped>
.popup-container {
	align-items: center;
	background-color: white;
	border: solid 1px map-get($colors, popup-border);
	border-radius: 5px;
	box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.11);
	display: flex;
	flex-direction: column;
	justify-content: center;
  min-height: 89px;
	min-width: 176px;
	opacity: 0;
	padding: 11px 16px;
	position: absolute;
	top: -78px;
	transition: opacity .2s ease-in, transform .2s ease-in, z-index .2s ease-in;
	z-index: -1;

	&::after {
		border-left: 10px solid map-get($colors, popup-border);
		border-right: 10px solid map-get($colors, popup-border);
		border-top: 10px solid white;
		bottom: -10px;
		position: absolute;
	}

	.close-button {
		color: white;
		cursor: pointer;
		background-color: black;
		border-radius: 50%;
		font-weight: bolder;
		height: 15px;
		position: absolute;
		right: 5px;
		top: 5px;
		width: 15px;
	}

	.maid-actions {
		display: flex;
	}

	.maid-profile {
		display: flex;
		margin: 5px 0 2px 0;
	}

	.maid-clean {
		display: flex;
		margin-bottom: 4px;
	}

	.maid-image {
		border-radius: 50%;
		margin-right: 5px;
	}

	.description-text {
  	color: map-get($colors, default-button-color);
		font-family: map-get($fonts, regular);
  	font-size: 12px;
	}

	.value-text {
		color: map-get($colors, time-text);
		font-family: map-get($fonts, light);
		font-size: 12px;
		font-weight: 300;
	}

	.maid-name {
  	color: map-get($colors, default-dark);
  	font-family: map-get($fonts, medium);
  	font-size: 15px;
  	font-weight: 500;
	}

	.btn-maid {
		border-radius: 100px;
		background-color: map-get($colors, default-button-color);
  	color:white;
  	font-family: map-get($fonts, semibold);
  	font-size: 11px;
  	font-weight: 600;
		height: 17px;
		margin-left: 5px;
  	text-align: center;
		width: 49px;
	}

}
</style>


// WEBPACK FOOTER //
// PopupMaid.vue?36d7d4ce